import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useAuth } from '@/contexts/auth-context';

function ProfileRedirect() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user?.id) {
      navigate({ to: '/home', replace: true });
      return;
    }
    navigate({
      to: '/user/$userId',
      params: { userId: user.id },
      search: { from: 'profile' },
      replace: true,
    });
  }, [user?.id, navigate]);

  return null;
}

export const Route = createFileRoute('/_authenticated/profile')({
  component: ProfileRedirect,
});
